import BackgroundView from './BackgroundView';

export default BackgroundView;
